// src/app/core/components/mainPagecomp/HomePromptComposerPageController.ts
import { hapticFeedback } from "@tma.js/sdk";
import type { NavigateFunction } from "react-router-dom";

const safeHaptic = (callback: () => void) => {
  try { callback(); } catch {}
};

export class HomePromptComposerPageController {
  constructor(private readonly navigate: NavigateFunction) {}

  syncTextareaHeight(textarea: HTMLTextAreaElement | null): void {
    if (!textarea) return;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  submit(prompt: string): void {
    const nextPrompt = prompt.trim();
    if (!nextPrompt) return;
    safeHaptic(() => hapticFeedback.impactOccurred("medium"));
    console.log('[HomePromptComposerPageController] navigating to /text-generation with', nextPrompt);
    this.navigate("/text-generation", { state: { initialPrompt: nextPrompt } });
  }

  applyQuickPrompt(nextPrompt: string, focus: () => void, setPrompt: (value: string) => void): void {
    setPrompt(nextPrompt);
    focus();
    safeHaptic(() => hapticFeedback.selectionChanged());
  }

  async copyPrompt(value: string, id: string, setCopiedId: (id: string | null) => void): Promise<void> {
    try {
      await navigator.clipboard.writeText(value);
      setCopiedId(id);
      safeHaptic(() => hapticFeedback.notificationOccurred("success"));
      window.setTimeout(() => setCopiedId(null), 1500);
    } catch (error) {
      console.error("Не удалось скопировать prompt", error);
    }
  }
}